<template>
    <div class="transfer-options">
        <div class="transfer-options__container">
            <h3 class="transfer-options__title">
                {{ blok.options_component.content?.title }}
            </h3>
            <Carousel
                v-if="blok.options_component.content"
                v-bind="carouselSettings"
                :breakpoints="carouselBreakpoints"
            >
                <Slide v-for="(block, index) in blok.options_component.content.options" :key="index">
                    <div v-if="block" class="transfer-options__box">
                        <div class="transfer-options__item">
                            <h3 class="transfer-options__titles">
                                {{ block?.title }}
                            </h3>
                            <NuxtImg
                                v-if="block.image?.filename"
                                :src="block.image.filename"
                                :title="block.image.title"
                                :alt="block.image.alt"
                                provider="storyblok"
                                format="webp"
                                loading="lazy"
                            />
                        </div>
                        <div class="transfer-options__info">
                            <button class="text-[#3992ec]" @click="openModal(block)">MORE INFO</button>
                            <TransferModal
                                v-if="showModal"
                                :transfer-chosen="transferChosen"
                                @close="closeModal"
                            ></TransferModal>
                        </div>
                    </div>
                </Slide>

                <template #addons>
                    <Navigation />
                </template>
            </Carousel>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4TransferOptionsContainerConfig } from '~/types/components/L4TransferOptionsContainer';
import type { IL4TransferOption } from '~/types';
// @ts-ignore
import { Carousel, Slide, Navigation } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

const { blok } = defineProps<{ blok: IL4TransferOptionsContainerConfig }>();

const showModal: Ref<boolean> = ref(false);
const transferChosen: Ref<null | IL4TransferOption> = ref(null);

const carouselSettings = {
    itemsToShow: 1,
    snapAlign: 'center',
};
// breakpoints are mobile first
// any settings not specified will fallback to the carousel settings
const carouselBreakpoints = {
    // 768px and up
    768: {
        itemsToShow: 2,
        snapAlign: 'center',
    },
    // 1050 and up
    1050: {
        itemsToShow: 4,
        snapAlign: 'start',
    },
};

const openModal = (transfer: IL4TransferOption) => {
    transferChosen.value = transfer;
    showModal.value = true;
};
const closeModal = () => {
    showModal.value = false;
};
</script>

<style lang="postcss" scoped>
.transfer-options {
    @apply my-0  pb-8 pt-3 px-4 lg:px-0 bg-white;
    &__container {
        @apply mx-auto max-w-5xl;
    }
    &__title {
        @apply text-2xl font-bold text-bodypurple;
    }
    &__box {
        @apply box-border border border-solid border-[#edebee] flex flex-col justify-around mx-2.5 mb-[1px];
    }
    &__item {
        @apply flex flex-col justify-between;
    }
    h3 {
        @apply text-bodypurple font-bold py-3;
    }
    &__info {
        @apply border-[#edebee] border-solid border-t h-9 flex items-center justify-center;
    }
    &__titles {
        @apply text-base flex pl-2;
    }
    &__img {
        @apply lg:h-[90px];
    }
    :deep(.carousel) {
        &__prev,
        &__next {
            @apply bg-bodypurple rounded-[20px] opacity-75 h-7 h-7;
        }
        &__prev {
            @apply left-[-2.3%];
        }
        &__next {
            @apply absolute right-[-2.3%];
        }
        &__icon {
            @apply z-[100] bg-transparent stroke-white stroke-[2px];
        }
    }
}
</style>
